/* template */
<template><span class="vam"><span v-for="(item, index) in (texts)" :key="item.index" :style="[(item.highlight ? highlightStyle : computedCommonStyle)] | transRpxStyle" class="vam">{{ item.value }}</span><slot/></span></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m10de904a"}'>
  .vam
    vertical-align middle
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m10de904a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex10de904a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex10de904a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m10de904a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index10de904a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
